import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '@environments/environment';
import { PropertyRoles, User, UserProfile } from '@app/_models';
import { MessageResponse } from '@app/_models/responses';
import { RequestAccessList } from '@app/_models/device-users';
import { Community } from '@app/_models/community';
import { Property } from '@app/_models/propery.model';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    requestUserDeletion(formdata: any) {
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');

        return this.http.post<MessageResponse>(`${environment.apiUrl}/api/account/dp/request/delete`, formdata, { headers: header});
    }

    confirmUserDeletion(formdata: any) {
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');

        return this.http.post<MessageResponse>(`${environment.apiUrl}/api/account/dp/delete`, formdata, { headers: header});
    }
    
    getAll() {
        return this.http.get<User[]>(`${environment.apiUrl}/api/users`);
    }

    getUserProfile(username: string) {
        return this.http.get<UserProfile>(`${environment.apiUrl}/api/userprofile/` + username);
    }

    getAllUserProfiles() {
        return this.http.get<UserProfile[]>(`${environment.apiUrl}/api/userprofiles/list`);
    }

    registerUser(formdata: any) {
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');

        return this.http.post<MessageResponse>(`${environment.apiUrl}/registration`, formdata, { headers: header});
    }

    requestPasswordReset(formdata: any) {
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');

        return this.http.post<MessageResponse>(`${environment.apiUrl}/api/password/reset`, formdata, { headers: header });
    }

    requestUsernameDetails(formdata: any) {
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');

        return this.http.post<MessageResponse>(`${environment.apiUrl}/api/username/query`, formdata, { headers: header });
    }

    updateUserRole(formdata: any) {
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');
        return this.http.post<MessageResponse>(`${environment.apiUrl}/api/user/property/role`, formdata, { headers : header });
    }

    changePassword(formdata: any) {
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');

        return this.http.post<MessageResponse>(`${environment.apiUrl}/api/password/change`, formdata, {headers: header});
    }

    getRequestAccessList(propertyid: number) {
        return this.http.get<RequestAccessList[]>(`${environment.apiUrl}/api/access/request/` + propertyid);
    }

    getPropertyRoleApprovalList() {
        return this.http.get<PropertyRoles[]>(`${environment.apiUrl}/api/user/property/details/approve`);
    }

    approveUserPropertyRole(propertyid: number, approverdata: any) {
        return this.http.put<MessageResponse>(`${environment.apiUrl}/api/user/property/roles/`+propertyid, approverdata);
    }

    removeUserPropertyRole(propertyid: number) {
        return this.http.delete<MessageResponse>(`${environment.apiUrl}/api/user/property/roles/`+propertyid);
    }
    // getCommunityByRoleAccessList(username,rolename) {
    //     return this.http.get<Community[]>(`${environment.apiUrl}/api/user/community/` + username + `/` + rolename);
    // }
    getPropertiesByRoleAccessList(username: string, rolename: string) {
        //return this.http.get<Community[]>(`${environment.apiUrl}/api/user/community/` + username + `/` + rolename);
        return this.http.get<Property[]>(`${environment.apiUrl}/api/user/property/` + username + `/` + rolename);
    }

    getAllPropertiesRoleAccessList() {
        return this.http.get<Property[]>(`${environment.apiUrl}/api/properties`);
    }
}